<ngx-page-container>
  <h1>Tasks</h1>
  <ngx-search [(value)]="search"></ngx-search>
  <table class="table table-hover" style="margin-top: 1rem;">
    <thead>
    <tr>
      <th scope="col" class="text">Customer</th>
      <th scope="col" class="text">Project</th>
      <th scope="col" class="text">Topic</th>
      <th scope="col" class="text-center">Responsible</th>
      <th scope="col" class="text-center">Action</th>
      <th scope="col" class="text-center">Due</th>
      <th></th>
    </tr>
    </thead>
    <tbody>
      <tr *ngFor="let task of filter(search, tasks)" (click)="complete(task)" [class.completed]="task.completed">
        <td>{{task.business}}</td>
        <td>{{task.project}}</td>
        <td>{{(task.topic != null && task.topic.length > 60) ? (task.topic | slice:0:60)+'...':(task.topic)}}</td>
        <td>{{task.responsible}}</td>
        <td>{{task.todo}}</td>
        <td>{{task.due | date:'MMM dd, yyyy'}}</td>
        <td><ngx-form-check [(value)]="task.completed" (valueChange)="complete(task)"></ngx-form-check></td>
      </tr>
    </tbody>
  </table>
</ngx-page-container>

